var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrowBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.56266 13.0833L1.06266 7.58332C0.979329 7.49999 0.920163 7.40971 0.885163 7.31249C0.850718 7.21526 0.833496 7.1111 0.833496 6.99999C0.833496 6.88888 0.850718 6.78471 0.885163 6.68749C0.920163 6.59026 0.979329 6.49999 1.06266 6.41665L6.56266 0.916654C6.71544 0.763876 6.90627 0.683876 7.13516 0.676654C7.36461 0.669987 7.56266 0.749987 7.72933 0.916654C7.896 1.06943 7.98294 1.26027 7.99016 1.48915C7.99683 1.7186 7.91683 1.91665 7.75016 2.08332L3.66683 6.16665H12.9793C13.2154 6.16665 13.4135 6.24638 13.5735 6.40582C13.7329 6.56582 13.8127 6.76388 13.8127 6.99999C13.8127 7.2361 13.7329 7.43388 13.5735 7.59332C13.4135 7.75332 13.2154 7.83332 12.9793 7.83332H3.66683L7.75016 11.9167C7.90294 12.0694 7.98294 12.2639 7.99016 12.5C7.99683 12.7361 7.91683 12.9305 7.75016 13.0833C7.59738 13.25 7.40294 13.3333 7.16683 13.3333C6.93072 13.3333 6.72933 13.25 6.56266 13.0833Z",
    fill: "url(#paint0_linear_219_807)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_219_807",
    x1: 0.833496,
    y1: 7.0048,
    x2: 13.8127,
    y2: 7.0048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E93FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3153C7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowBlue);
export default __webpack_public_path__ + "static/media/left-arrow-blue.4a68216aab2c20973feaa353e93f7ae2.svg";
export { ForwardRef as ReactComponent };